import React, { useEffect } from 'react';
import logo from '../../images/logo.png'
import useAuth from '../../hooks/useAuth';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment/moment';

const DriverTracking = () => {

    const { vehicleData, outletCode, deliveryOutlets, setDeliveryOutlets } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        !outletCode && navigate('/')
    }, [outletCode, navigate])

    const handleStart = (index, code) => {

        let thisOutletData = vehicleData.deliveryOutlets.find(data => data.code === code)

        thisOutletData = {
            ...thisOutletData,
            vehicle_start: Date.now()
        }

        setDeliveryOutlets(prevArray => {
            const newArray = [...prevArray];
            newArray[index] = { ...newArray[index], ...thisOutletData };
            return newArray;
        })
    }

    const handleReached = (index, code) => {

        let thisOutletData = vehicleData.deliveryOutlets.find(data => data.code === code)

        thisOutletData = {
            ...thisOutletData,
            vehicle_reached: Date.now()
        }

        setDeliveryOutlets(prevArray => {
            const newArray = [...prevArray];
            newArray[index] = { ...newArray[index], ...thisOutletData };
            return newArray;
        })

    }

    const handleRS = (index, code) => {

        let thisOutletData = vehicleData.deliveryOutlets.find(data => data.code === code)

        thisOutletData = {
            ...thisOutletData,
            receiving_start: Date.now()
        }

        setDeliveryOutlets(prevArray => {
            const newArray = [...prevArray];
            newArray[index] = { ...newArray[index], ...thisOutletData };
            return newArray;
        })
    }

    const handleRE = (index, code) => {

        let thisOutletData = vehicleData.deliveryOutlets.find(data => data.code === code)

        thisOutletData = {
            ...thisOutletData,
            receiving_end: Date.now()
        }

        setDeliveryOutlets(prevArray => {
            const newArray = [...prevArray];
            newArray[index] = { ...newArray[index], ...thisOutletData };
            return newArray;
        })
    }

    const handleGRNH = (index, code) => {

        let thisOutletData = vehicleData.deliveryOutlets.find(data => data.code === code)

        thisOutletData = {
            ...thisOutletData,
            grn_handover: Date.now()
        }

        setDeliveryOutlets(prevArray => {
            const newArray = [...prevArray];
            newArray[index] = { ...newArray[index], ...thisOutletData };
            return newArray;
        })
    }

    useEffect(() => {
        const details = {
            deliveryOutlets
        }
        const fetchData = async () => {
            try {
                const response = await fetch(`http://localhost:5000/vehicleWiseData/${vehicleData._id}`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(details)
                })
                const result = await response.json()
                console.log(result)
            }
            catch {
                fetchData()
            }
        }
        fetchData()
    }, [vehicleData._id, deliveryOutlets])

    return (
        <div className='bg-brand'>
            <div className="container">
                <div className="d-flex justify-content-center align-items-center pt-3">
                    <img className='img-fluid' src={logo} alt="vehicle" />
                    <h1 style={{ lineHeight: '50px' }} className='fw-bold mt-2'>eTracker</h1>
                </div>

                <div className="my-3 bg-white shadow-sm rounded p-2">
                    {
                        vehicleData.email &&
                        deliveryOutlets.map((outlet, index) =>
                            <div key={index}>
                                <div className="d-flex align-items-center ms-1 py-2">
                                    <div className="round">{index + 1}</div>
                                    <h2 className='h6 mb-0 ms-1'>{outlet.name}</h2>
                                </div>

                                <div style={{ borderLeft: '1px solid #bdbdbd' }} className="ms-3">
                                    {
                                        outlet.vehicle_start ?
                                            <>
                                                <p style={{ fontSize: '12px' }} className='mb-0 ms-3 text-brand-danger'>Vehicle Started at {moment(outlet.vehicle_start).format('LTS')}</p>
                                                {
                                                    !outlet.vehicle_reached &&
                                                    <button onClick={() => handleReached(index, outlet.code)} className='btn btn-danger btn-sm mt-2 ms-2 px-3'>Reached</button>
                                                }
                                            </>
                                            :
                                            <button onClick={() => handleStart(index, outlet.code)} className='btn btn-success btn-sm mt-2 ms-2 px-3'>Start</button>
                                    }

                                    {
                                        outlet.vehicle_reached &&
                                        <>
                                            <p style={{ fontSize: '12px' }} className='mb-0 ms-3 text-brand-danger'>Vehicle Reached at {moment(outlet.vehicle_reached).format('LTS')}</p>
                                            {
                                                !outlet.receiving_start &&
                                                <button onClick={() => handleRS(index, outlet.code)} className='btn btn-success btn-sm mt-2 ms-2 px-3'>Receiving Start</button>
                                            }
                                        </>
                                    }

                                    {
                                        outlet.receiving_start &&
                                        <>
                                            <p style={{ fontSize: '12px' }} className='mb-0 ms-3 text-brand-danger'>Receiving Started at {moment(outlet.receiving_start).format('LTS')}</p>
                                            {
                                                !outlet.receiving_end &&
                                                <button onClick={() => handleRE(index, outlet.code)} className='btn btn-danger btn-sm mt-2 ms-2 px-3'>Receiving End</button>
                                            }
                                        </>
                                    }

                                    {
                                        outlet.receiving_end &&
                                        <>
                                            <p style={{ fontSize: '12px' }} className='mb-0 ms-3 text-brand-danger'>Receiving Ended at {moment(outlet.receiving_end).format('LTS')}</p>
                                            {
                                                !outlet.grn_handover &&
                                                <button onClick={() => handleGRNH(index, outlet.code)} className='btn btn-primary btn-sm mt-2 ms-2 px-3'>GRN Handover</button>
                                            }
                                        </>
                                    }

                                    {
                                        outlet.grn_handover &&
                                        <>
                                            <p style={{ fontSize: '12px' }} className='mb-0 ms-3 text-brand-danger'>GRN Handover at {moment(outlet.grn_handover).format('LTS')}</p>
                                        </>
                                    }
                                </div>
                            </div>
                        )
                    }
                </div>

                {
                    vehicleData?.email &&
                    deliveryOutlets.every(obj => 'grn_handover' in obj) &&
                    <Link to='/'><button className='btn-brand-submit w-100'>STO Delivery Done</button></Link>
                }

            </div>
        </div>
    );
};

export default DriverTracking;